/*
 * Blog category page: Newest / Oldest sorting and pagination in the browser.
 *
 * The section renders every post of the blog once, newest first. This script
 * reorders them for "Oldest", shows one page at a time, and draws the pager
 * using the front team's lum-pager markup (styled in lum-base.css).
 * The current page and sort are kept in the URL (?page=2&sort=oldest) so a
 * page can be shared or reloaded.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.lumReady) return;
    root.dataset.lumReady = '1';

    var grid = root.querySelector('[data-lum-blog-grid]');
    var pager = root.querySelector('[data-lum-blog-pager]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-sort]'));
    if (!grid || !pager) return;

    var perPage = parseInt(root.dataset.perPage, 10) || 12;
    var prevLabel = root.dataset.prevLabel || 'Previous';
    var nextLabel = root.dataset.nextLabel || 'Next';
    var cards = Array.prototype.slice.call(grid.children);
    var params = new URLSearchParams(window.location.search);
    var sort = params.get('sort') === 'oldest' ? 'oldest' : 'newest';
    var page = parseInt(params.get('page'), 10) || 1;

    function ordered() {
      var list = cards.slice().sort(function (a, b) {
        return Number(b.dataset.lumDate) - Number(a.dataset.lumDate);
      });
      return sort === 'oldest' ? list.reverse() : list;
    }

    function pageNumbers(current, total) {
      // first and last always, two pages on each side of the current one, gaps between
      var win = 2;
      var out = [];
      for (var i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - win && i <= current + win)) out.push(i);
        else if (out[out.length - 1] !== 'gap') out.push('gap');
      }
      return out;
    }

    function link(p) {
      var q = new URLSearchParams(window.location.search);
      q.set('page', p);
      if (sort === 'oldest') q.set('sort', 'oldest');
      else q.delete('sort');
      return '?' + q.toString();
    }

    function drawPager(total) {
      if (total <= 1) {
        pager.innerHTML = '';
        pager.style.display = 'none';
        return;
      }
      pager.style.display = '';
      var html = '<ul class="lum-pager__list">';
      html += '<li class="lum-pager__item" data-role="prev">';
      html += page > 1
        ? '<a class="lum-pager__edge" href="' + link(page - 1) + '" data-page="' + (page - 1) + '"><i class="lum-icon lum-icon--chevron-left lum-icon--sm"></i>' + prevLabel + '</a>'
        : '<span class="lum-pager__edge lum-pager__edge--disabled"><i class="lum-icon lum-icon--chevron-left lum-icon--sm"></i>' + prevLabel + '</span>';
      html += '</li>';
      pageNumbers(page, total).forEach(function (n) {
        if (n === 'gap') {
          html += '<li class="lum-pager__item" data-role="gap" data-keep><span class="lum-pager__gap">…</span></li>';
        } else if (n === page) {
          html += '<li class="lum-pager__item" data-role="page" data-keep aria-current="page"><span class="lum-pager__link lum-pager__link--current">' + n + '</span></li>';
        } else {
          var keep = (n === 1 || n === total) ? ' data-keep' : '';
          html += '<li class="lum-pager__item" data-role="page"' + keep + '><a class="lum-pager__link" href="' + link(n) + '" data-page="' + n + '">' + n + '</a></li>';
        }
      });
      html += '<li class="lum-pager__item" data-role="next">';
      html += page < total
        ? '<a class="lum-pager__edge" href="' + link(page + 1) + '" data-page="' + (page + 1) + '">' + nextLabel + '<i class="lum-icon lum-icon--chevron-right lum-icon--xs"></i></a>'
        : '<span class="lum-pager__edge lum-pager__edge--disabled">' + nextLabel + '<i class="lum-icon lum-icon--chevron-right lum-icon--xs"></i></span>';
      html += '</li></ul>';
      pager.innerHTML = html;
    }

    function render(updateUrl) {
      var list = ordered();
      var total = Math.max(1, Math.ceil(list.length / perPage));
      page = Math.min(Math.max(1, page), total);
      var start = (page - 1) * perPage;
      // put the cards in the chosen order, then show only the current page
      list.forEach(function (card, i) {
        grid.appendChild(card);
        card.style.display = i >= start && i < start + perPage ? '' : 'none';
      });
      buttons.forEach(function (b) {
        var active = b.dataset.sort === sort;
        b.classList.toggle('lum-blog-filter__item--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      drawPager(total);
      if (updateUrl && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', link(page));
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.sort === sort) return;
        sort = b.dataset.sort;
        page = 1;
        render(true);
      });
    });

    pager.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-page]');
      if (!a) return;
      e.preventDefault();
      page = parseInt(a.dataset.page, 10);
      render(true);
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render(false);
  }

  function initAll() {
    document.querySelectorAll('[data-lum-blog-category]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // the Theme Editor re-renders a section after a setting changes
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-lum-blog-category]'));
  });
})();